import {
  ArrowDownward,
  ArrowUpward,
  Download,
  History,
  CalendarMonth,
  AttachFileOutlined,
  ExpandMore,
  Share,
  Delete,
} from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { useState, useEffect } from 'react';
import { Badge, Button, Col, Container, Row, Table } from 'react-bootstrap';
import CommonPagination from './pagination/CommonPagination';
import moment from 'moment';
import Battery from './Battery';
import TableLoader from './TableLoader';
import CircularProgress from '@mui/material/CircularProgress';
import DatePicker from './date/DatePicker';
import axios from 'axios';
import { downloadFileServer, postDatatoServer } from '../utils/apiBase';
import ContextHelper from '../ContextHooks/ContextHelper';
import { useLocation } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Bar, Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, ArcElement, BarElement, Title, Tooltip, Legend } from 'chart.js';
import StackedBarChart from './StackedBarChart';
import ReportChart from './ReportChart';
import ShareModal from './ShareModal';
import ReportDetailsModal from './ReportDetailsModal';
import ExpandDropdown from './ExpandDropdown';
import DeleteModal from './DeleteModal';
import toast from 'react-hot-toast';

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend);

const CommonTable = (props) => {
  const {
    data,
    columns,
    isLoading,
    setIsLoading,
    setStartDate,
    setEndDate,
    setIsDataFetched,
    setUploadSuccess,
    setIsDownloading,
    isDownloading,
  } = props;
  const { currentUser } = ContextHelper();
  const [sortingBy, setSortingBy] = useState('');
  const [sortType, setSortType] = useState('asc');
  const [ascending, setAscending] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tempSortData, setTempSortData] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [downloading, setDownloading] = useState({});
  const [downloadingRows, setDownloadingRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [dashboardView, setDashboardView] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reportLink, setReportLink] = useState('');
  const [toggle, setToggle] = useState(true);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const location = useLocation();
  const path = location.pathname;
  const baseUrl = window.location.origin;
  const [columnVisibility, setColumnVisibility] = useState(() => {
    return columns.reduce((acc, column) => {
      acc[column.key] = column.defaultVisible;
      return acc;
    }, {});
  });
  useEffect(() => {
    setIsLoading(true);
    setTableData(data);
    setTempSortData(data);
    setIsLoading(false);
    setCurrentPage(1);
    setUploadSuccess(false);
  }, [data, showModal]);

  const exportToExcel = (data, filename) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, filename);
  };

  const handleRowSelection = (rowId) => {
    if (selectedRows.includes(rowId)) {
      setSelectedRows(selectedRows.filter((id) => id !== rowId));
    } else {
      setSelectedRows([...selectedRows, rowId]);
    }
  };

  const handleDownload = async (drRemark) => {
    try {
      setIsDownloading(true);
      setDownloadingRows((prevState) => [...prevState, drRemark]);

      const response = await axios.get(`${baseUrl}/studies/${drRemark}/archive`, {
        headers: {
          Authorization: 'Basic cGFjc2FkbWluOmxrc2okODc2MzQ1',
        },
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
      });

      const downloadUrl = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `${drRemark}.zip`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setDownloadingRows((prevState) => prevState.filter((item) => item !== drRemark));
    } catch (error) {
      console.error(error);
      setDownloadingRows((prevState) => prevState.filter((item) => item !== drRemark));
    } finally {
      setIsDownloading(false);
    }
  };

  const totalReports = data.length;

  const { pendingReports, urgentReports, completeReports } = data.reduce(
    (counts, item) => {
      if (!item.reports || item.reports.length === 0) {
        counts.pendingReports++;
      }
      if (item.isUrgent) {
        counts.urgentReports++;
      }
      if (item.reports && item.reports.length > 0) {
        counts.completeReports++;
      }
      return counts;
    },
    { pendingReports: 0, urgentReports: 0, completeReports: 0 }
  );

  const doughnutData = {
    labels: ['Total', 'Pending', 'Urgent', 'Complete'],
    datasets: [
      {
        data: [totalReports, pendingReports, urgentReports, completeReports],
        backgroundColor: ['#36A2EB', '#FF6384', '#FFCE56', '#198754'],
      },
    ],
  };

  function getVariableWithType(a, b) {
    let keyA = a;
    let keyB = b;
    if (!isNaN(parseFloat(a))) {
      keyA = eval(parseFloat(a));
      keyB = eval(parseFloat(b));
    }
    return { keyA, keyB };
  }

  function handleSorting(keyName) {
    // List of columns that should not be sortable
    const nonSortableColumns = ['tat', 'check', 'history', 'drRemark', 'share', 'deleteCase', 'report', 'other', 'HistoryIMG'];
    
    if (nonSortableColumns.includes(keyName)) {
      return;
    }
    
    const sorted = [...tableData];
  
    if (sortingBy !== keyName) {
      sorted.sort((a, b) => {
        const { keyA, keyB } = getVariableWithType(a[keyName], b[keyName]);
  
        if (typeof keyA === 'string' && typeof keyB === 'string') {
          return keyA.localeCompare(keyB);
        } else {
          return keyA < keyB ? -1 : keyA > keyB ? 1 : 0;
        }
      });
  
      setTableData(sorted);
      setSortType('asc');
      setAscending(false);
      setSortingBy(keyName);
    } else if (sortType === 'asc') {
      sorted.sort((a, b) => {
        const { keyA, keyB } = getVariableWithType(a[keyName], b[keyName]);
  
        if (typeof keyA === 'string' && typeof keyB === 'string') {
          return keyB.localeCompare(keyA);
        } else {
          return keyA > keyB ? -1 : keyA < keyB ? 1 : 0;
        }
      });
  
      setTableData(sorted);
      setSortType('desc');
      setAscending(true);
    } else {
      setTableData(tempSortData);
      setSortType('');
      setSortingBy('');
    }
  }

  const handleBulkDownload = async () => {
    for (const drRemark of selectedRows) {
      await handleDownload(drRemark);
    }
  };

  const handleReportClick = (report) => {
    setSelectedReport(report);
    setShowModal(true);
  };

  const extractedInfo = data.map((item) => {
    return {
      StudyStatus: 'Final Review Subbmitted',
      CenterName: item.location,
      Name: item.name,
      PatientID: item.patientID,
      assignedTo: item.assignedTo,
      StudyName: item.study,
      SeriesName: item.images,
      Images: item.images,
      StudyDate: item.StudyDate,
      history: item.history,
      UploadDate: item.date,
      ReportedBy: item.ReportedBy,
      Report: item.reports.map((report) => report.uri).join(', '),
      Modality: item.modality,
      HistoryTime: item.historyTime ? new Date(item.historyTime).toLocaleString('en-IN') : '',
      ReportTime: item.reportTime ? new Date(item.reportTime).toLocaleString('en-IN') : '',
    };
  });

  const handleExport = () => {
    exportToExcel(extractedInfo, 'reports.xlsx');
  };

  const patientsByDate = {};

  filteredTableData.forEach((patient) => {
    const date = patient?.date?.split(',')[0];
    if (patientsByDate[date]) {
      patientsByDate[date]++;
    } else {
      patientsByDate[date] = 1;
    }
  });

  const dates = Object.keys(patientsByDate);
  const patientCounts = Object.values(patientsByDate);

  const chartData = {
    labels: dates,
    datasets: [
      {
        maxBarThickness: 40,
        label: 'Number of Patients',
        backgroundColor: '#508AA8',
        data: patientCounts,
      },
    ],
  };

  const downloadImages = async (images, itemId) => {
    try {
      setDownloading((prevLoadingMap) => ({ ...prevLoadingMap, [itemId]: true }));

      for (const image of images) {
        const response = await downloadFileServer({
          end_point: `getHistory/${image.uri}`,
          props: `report_${image.uri}`,
        });
      }

      setDownloading((prevLoadingMap) => ({ ...prevLoadingMap, [itemId]: false }));
    } catch (error) {
      console.error('Error downloading images:', error);
      setDownloading((prevLoadingMap) => ({ ...prevLoadingMap, [itemId]: false }));
    }
  };

  const handleDeleteReport = () => {
    postDatatoServer({
      end_point: `deleteCase/?id=${deleteId.id}`,
      body: deleteId,
      call_back: (res) => {
        if (res?.status === 'success' && res?.response) {
          toast.success(res.response.message);
          setDeleteModal(false);
          setUploadSuccess(true);
        } else {
          toast.error(res.response.message);
        }
      },
      props: { header: true, token: currentUser?.token },
    });
  };

  const handleDelete = (item) => {
    setDeleteId(item);
    setDeleteModal(true);

  };

  const handleShareClick = (studyUUID) => {
    const linkData = `${baseUrl}/viewer?StudyInstanceUIDs=${studyUUID}&UserName=${currentUser.name}`;
    setReportLink(linkData);
    setIsModalOpen(true);
  };

  return (
    <>
      {isModalOpen && (
        <ShareModal reportLink={reportLink} show={isModalOpen} handleClose={() => setIsModalOpen(false)} />
      )}
      {deleteModal && (
        <DeleteModal
          deleteModal={deleteModal}
          handleDeleteReport={handleDeleteReport}
          closeModal={() => setDeleteModal(false)}
          text={'Report'}
        />
      )}
      <ReportDetailsModal
        closeModal={() => setShowModal(false)}
        setSelectedReport={setSelectedReport}
        selectedReport={selectedReport}
        showModal={showModal}
        setUploadSuccess={setUploadSuccess}
      />

      <Container fluid>
        <Row className="mb-4">
          <Col>
            <>
              <Row className="my-2 justify-content-between">
                <Col>
                  <h5 className="mb-0 fs-18">{path === '/add-report' ? 'Add Report' : 'View Report'}</h5>
                </Col>
                <Col>
                  <div
                    className={`expand_more text-end ${toggle && 'expand_more_down'}`}
                    onClick={() => setToggle(!toggle)}
                  >
                    <ExpandMore />
                  </div>
                </Col>
              </Row>

              {(path !== '/patient-report' && toggle && (
                <Row className="my-2 align-items-center">
                  <Col>
                    <div className="d-flex align-items-center flex-wrap text-nowrap gap">
                      <DatePicker
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                        setIsDataFetched={setIsDataFetched}
                      />
                      {path == '/add-report' && (
                        <Button
                          variant=""
                          className="login-btn base-color-bg fs-15 text-white fw-semibold"
                          onClick={handleBulkDownload}
                          disabled={selectedRows.length === 0 || selectedRows.length > 5}
                        >
                          Bulk Download
                        </Button>
                      )}

                      {!dashboardView && (
                        <Button
                          variant=""
                          className="login-btn base-color-bg fs-15 text-white fw-semibold"
                          onClick={handleExport}
                          disabled={isLoading || filteredTableData.length == 0}
                        >
                          Download Reports
                        </Button>
                      )}

                      <>
                        {(!dashboardView && (
                          <Button
                            variant=""
                            className="login-btn fs-15 base-color-bg text-white fw-semibold"
                            onClick={() => setDashboardView(true)}
                          >
                            Dashboard Reports
                          </Button>
                        )) || (
                          <Button
                            variant=""
                            className="login-btn fs-15 base-color-bg text-white fw-semibold"
                            onClick={() => setDashboardView(false)}
                          >
                            {(path == '/add-report' && 'Add Reports') || 'View Reports'}
                          </Button>
                        )}
                      </>
                    </div>
                  </Col>
                  <Col>
                    <div className="d-flex align-items-center justify-content-end gap text-nowrap flex-wrap">
                      <h6 className="fw-semibold fs-16 text-capitalize mb-0">
                        User Logged In:
                        <Badge bg="" className="base-color-bg ms-2">
                          {currentUser.name}
                        </Badge>
                      </h6>
                      <h6 className="fw-semibold fs-16 text-capitalize mb-0">
                        Total Reports:
                        <Badge bg="" className="base-color-bg ms-2">
                          {totalReports}
                        </Badge>
                      </h6>
                      <h6 className="fw-semibold fs-16 text-capitalize mb-0">
                        Pending Reports:
                        <Badge bg="" className="base-color-bg ms-2">
                          {pendingReports}
                        </Badge>
                      </h6>
                    </div>
                  </Col>
                </Row>
              )) ||
                ''}
            </>

            {(toggle && (
              <ExpandDropdown
                dashboardView={dashboardView}
                setPageSize={setPageSize}
                selectedRows={selectedRows}
                columns={columns}
                setColumnVisibility={setColumnVisibility}
                columnVisibility={columnVisibility}
                setUploadSuccess={setUploadSuccess}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                setFilteredTableData={setFilteredTableData}
                setIsLoading={setIsLoading}
                tableData={tableData}
                pageSize={pageSize}
                setCurrentData={setCurrentData}
              />
            )) ||
              ''}
            {(!dashboardView && (
              <>
                {(isLoading && !isDownloading && <TableLoader />) || (
                  <div className="border rounded-3 bg-white text-nowrap">
                    <Table responsive hover className="mb-0">
                      <thead>
                        <tr className="base-color-bg text-white">
                          {columns.map((column, index) =>
                            columnVisibility[column.key] ? (
                              <th scope="col" key={index} className="text-center fs-15">
                                {[
                                  'tat',
                                  'check',
                                  'history',
                                  'drRemark',
                                  'share',
                                  'deleteCase',
                                  'report',
                                  'other',
                                  'HistoryIMG',
                                ].includes(column.key) ? (
                                  <div>{column.header}</div>
                                ) : (
                                  <div onClick={() => handleSorting(column.key)}>
                                    {column.header}
                                    {sortingBy === column.key && sortType === 'asc' && <ArrowUpward />}
                                    {sortingBy === column.key && sortType === 'desc' && <ArrowDownward />}
                                    {sortingBy !== column.key && (
                                      <>
                                        <ArrowUpward />
                                        <ArrowDownward />
                                      </>
                                    )}
                                  </div>
                                )}
                              </th>
                            ) : null
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {currentData.length > 0 ? (
                          currentData.map((item, index) => (
                            <tr key={index}>
                              {columns.map((column) =>
                                columnVisibility[column.key] ? (
                                  <td key={column.key} className="text-center fs-15">
                                    {column.key === 'history' ? (
                                      item[column.key] ? (
                                        <div title={item[column.key]}>
                                          <History className="text-success" />
                                        </div>
                                      ) : (
                                        <History />
                                      )
                                    ) : column.key === 'drRemark' ? (
                                      <div className="cursor-pointer">
                                        {downloadingRows.includes(item.drRemark) ? (
                                          <CircularProgress size={24} />
                                        ) : (
                                          <Download
                                            className="base-color"
                                            onClick={() => handleDownload(item.drRemark)}
                                          />
                                        )}
                                      </div>
                                    ) : column.key === 'status' ? (
                                      <>
                                        {(() => {
                                          const badgeConditions = [
                                            {
                                              condition:
                                                !item.isUrgent && !item.assignedTo && item.reports.length === 0,
                                              label: 'Pending',
                                              bg: 'danger',
                                            },
                                            {
                                              condition: !item.isUrgent && item.assignedTo && item.reports.length === 0,
                                              label: 'Pending & Assigned',
                                              bg: 'purple-color',
                                            },
                                            {
                                              condition: item.isUrgent && item.assignedTo && item.reports.length === 0,
                                              label: 'Urgent & Assigned',
                                              bg: 'purple-color',
                                            },
                                            {
                                              condition: item.isUrgent && item.assignedTo && item.reports.length > 0,
                                              label: 'Urgent & Complete',
                                              bg: 'greenish-color',
                                            },
                                            {
                                              condition: !item.isUrgent && item.assignedTo && item.reports.length > 0,
                                              label: 'Assigned & Complete',
                                              bg: 'greenish-color',
                                            },
                                            {
                                              condition: item.isUrgent && !item.assignedTo && item.reports.length === 0,
                                              label: 'Urgent',
                                              bg: 'warning',
                                            },
                                            {
                                              condition: !item.isUrgent && !item.assignedTo && item.reports.length > 0,
                                              label: 'Complete',
                                              bg: 'success',
                                            },
                                            {
                                              condition: item.isUrgent && !item.assignedTo && item.reports.length > 0,
                                              label: 'Urgent & Complete',
                                              bg: 'base-color-bg',
                                            },
                                            {
                                              condition: item.reports.length === 0 && !item.assignedTo && item.isUrgent,
                                              label: 'Pending & Urgent',
                                              bg: 'orange-color',
                                            },
                                          ];

                                          const matchingBadge = badgeConditions.find((badge) => badge.condition);
                                          const badgeLabel = matchingBadge?.label?.toLowerCase() || '';

                                          const isComplete =
                                            badgeLabel.includes('complete') ||
                                            badgeLabel.includes('assigned & complete') ||
                                            badgeLabel.includes('urgent & complete');

                                          const isVerifier = currentUser?.type === 'verifier';

                                          return (
                                            <>
                                              {/* 1. Always show main status badge */}
                                              {matchingBadge && (
                                                <Badge bg={matchingBadge.bg}>{matchingBadge.label}</Badge>
                                              )}

                                              {/* 2. Only if Complete show Verified/Unverified */}
                                              {(isVerifier && isComplete && (
                                                <>
                                                  {item.isverifier === true ? (
                                                    <Badge className="ms-2" bg="success">
                                                      Verified
                                                    </Badge>
                                                  ) : (
                                                    <Badge className="ms-2" bg="danger">
                                                      Unverified
                                                    </Badge>
                                                  )}
                                                </>
                                              )) ||
                                                ''}
                                              {/* 3. Only if Complete + Verified, show Approved/Unapproved */}
                                              {isComplete &&
                                                (currentUser?.permissions?.report_approval === 'true' ||
                                                  currentUser?.permissions?.report_approval === true) && (
                                                  <>
                                                    {item.reportApproved === true ? (
                                                      <Badge className="ms-2" bg="success">
                                                        Approved
                                                      </Badge>
                                                    ) : (
                                                      <Badge className="ms-2" bg="secondary">
                                                        Unapproved
                                                      </Badge>
                                                    )}
                                                  </>
                                                )}
                                            </>
                                          );
                                        })()}
                                      </>
                                    ) : column.key === 'tat' ? (
                                      <Battery
                                        caseTime={item.historyTime ? new Date(item.historyTime).toLocaleString() : ''}
                                        reportTime={item.reportTime ? new Date(item.reportTime).toLocaleString() : ''}
                                      />
                                    ) : column.key === 'comments' ? (
                                      <CalendarMonth />
                                    ) : column.key === 'HistoryIMG' ? (
                                      <>
                                        {item.HistoryIMG === '0' ? (
                                          <Badge bg="danger">{item.HistoryIMG}</Badge>
                                        ) : (
                                          <Badge
                                            bg="success"
                                            className="cursor-pointer"
                                            onClick={() => downloadImages(item.historyFiles, item.id)}
                                          >
                                            {(downloading[item.id] && (
                                              <CircularProgress className="text-white" size={12} />
                                            )) ||
                                              item.HistoryIMG}
                                          </Badge>
                                        )}
                                      </>
                                    ) : column.key === 'other' ? (
                                      <a href={`${baseUrl}/viewer?StudyInstanceUIDs=${item.studyUUID}`} target="_blank">
                                        <VisibilityIcon
                                          sx={{
                                            fontSize: '24px',
                                          }}
                                        />
                                      </a>
                                    ) : column.key === 'share' ? (
                                      <button
                                        onClick={() => handleShareClick(item.studyUUID)}
                                        className="bg-transparent base-color"
                                        title="Share Report"
                                      >
                                        <Share
                                          sx={{
                                            fontSize: '24px',
                                          }}
                                        />
                                      </button>
                                    ) : column.key === 'share' ? (
                                      <button
                                        onClick={() => handleShareClick(item.studyUUID)}
                                        className="bg-transparent base-color"
                                        title="Share Report"
                                      >
                                        <Share
                                          sx={{
                                            fontSize: '24px',
                                          }}
                                        />
                                      </button>
                                    ) : column.key === 'deleteCase' ? (
                                      <button
                                        onClick={() => handleDelete(item)}
                                        className="bg-transparent text-danger"
                                        title="Delete Report"
                                      >
                                        <Delete
                                          sx={{
                                            fontSize: '24px',
                                          }}
                                        />
                                      </button>
                                    ) : column.key === 'source' ? (
                                      <div>{(item?.source == 'NA' && '-') || item?.source}</div>
                                    ) : column.key === 'report' ? (
                                      <AttachFileOutlined
                                        className="text-success cursor-pointer"
                                        onClick={() => handleReportClick(item)}
                                      />
                                    ) : column.key === 'check' ? (
                                      <input
                                        type="checkbox"
                                        className="form-check-input cursor-pointer"
                                        checked={selectedRows.includes(item.id)}
                                        onChange={() => handleRowSelection(item.id)}
                                      />
                                    ) : column.key === 'date' ? (
                                      moment(item[column.key], 'D/M/YYYY, h:mm:ss a').format('DD MMMM YYYY, h:mm:ss a')
                                    ) : column.key === 'images' ? (
                                      <>{item[column.key]}</>
                                    ) : item[column.key] ? (
                                      item[column.key]
                                    ) : (
                                      '-'
                                    )}
                                  </td>
                                ) : null
                              )}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="border-0 text-center fs-15" colSpan={columns.length}>
                              <p>No Data Found</p>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    {filteredTableData.length > 0 && (
                      <CommonPagination
                        data={filteredTableData}
                        setCurrentData={setCurrentData}
                        pageSize={pageSize}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    )}
                  </div>
                )}
              </>
            )) || (
              <Row className="mt-3">
                <Col lg={9}>
                  <div className="border rounded-3 bg-white p-3">
                    {(filteredTableData.length > 0 && <Bar data={chartData} />) || (
                      <h4 className="text-center fs-15">No Data Found</h4>
                    )}
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="border rounded-3 bg-white p-3">
                    {(filteredTableData.length > 0 && <Doughnut data={doughnutData} />) || (
                      <h4 className="text-center fs-15">No Data Found</h4>
                    )}
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="border rounded-3 bg-white p-3 mt-4">
                    {(filteredTableData.length > 0 && <StackedBarChart dataChart={filteredTableData} />) || (
                      <h4 className="text-center fs-15">No Data Found</h4>
                    )}
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="border rounded-3 bg-white p-3 mt-4">
                    {(filteredTableData.length > 0 && <ReportChart reports={filteredTableData} />) || (
                      <h4 className="text-center fs-15">No Data Found</h4>
                    )}
                  </div>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CommonTable;
